import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ReactSelect from 'components/theme/Select'
import { FormHelperText } from '@material-ui/core'
import { selectFromEmail, changeFromName } from 'actions/tasks'
import { list, read } from 'actions/data'
import { UseOwnerFrom } from './FromNumberSelect'

class FromEmailSelect extends Component {
  componentDidMount() {
    this.props.list('email/valid_sending_addresses', 'address')
    if (this.props.taskID === 'new') {
      if (this.props?.['email/verify_default_address_status']) {
        this.props.selectFromEmail({
          value: this.props?.['email/verify_default_address_status']?.address,
          label: `${
            this.props?.['email/verify_default_address_status']?.address
          }${
            this.props?.['email/verify_default_address_status']?.status !==
            'success'
              ? ' (unverified)'
              : ''
          }`,
          key: `${this.props?.['email/verify_default_address_status']?.address}SelectValue`,
        })
      }

      if (this.props.business_name) {
        this.props.changeFromName(this.props.business_name)
      }
    }
  }

  render() {
    const customStyles = {
      control: provided => ({
        ...provided,
        borderColor: this.props.error
          ? '#f44336'
          : this.props.warning
          ? '#d89300'
          : 'rgba(0, 0, 0, 0.23)',
        borderRadius: '28px',
        padding: '9px 0',
      }),
      menu: provided => ({ ...provided, zIndex: 2 }),
    }
    return (
      <div>
        <ReactSelect
          styles={customStyles}
          value={this.props.value}
          onChange={newValue => {
            // if (newValue.display_name) {
            // 	this.props.changeFromName(newValue.display_name)
            // }
            this.props.selectFromEmail(newValue)
          }}
          closeMenuOnSelect={false}
          options={this.props['email/valid_sending_addresses']}
          placeholder={'From Address'}
          isDisabled={this.props.disabled}
          isOptionDisabled={option => option.status !== 'success'}
        />
        <FormHelperText error={Boolean(this.props.error)}>
          {this.props.error}
        </FormHelperText>
        <UseOwnerFrom
          disabled={this.props.disabled}
          type="use_owner_from_address"
        />
      </div>
    )
  }
}

export default connect(
  state => {
    const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
    const stats = task?.sms_stats || task?.email_stats
    const campaignStatus =
      state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
    const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
    const disabled = Boolean(
      (stats && automationTypeSelected !== 'stage') ||
        campaignStatus === 'L' ||
        campaignStatus === 'C',
    )

    return {
      disabled,
      value: state.tasks.addOrEdit.fromEmailSelected,
      'email/valid_sending_addresses': Object.values(
        state.data?.['email/valid_sending_addresses'] || {},
      )?.map(el => ({
        ...el,
        value: el.address,
        label: `${el.address}${el.status !== 'success' ? ' (unverified)' : ''}`,
        key: `${el.address}SelectValue`,
      })),
      taskID: state.tasks.addOrEdit.taskID,
      'email/verify_default_address_status':
        state.data['email/verify_default_address_status'],
      business_name: state.data?.account?.business_name,
    }
  },
  dispatch => {
    return bindActionCreators(
      { selectFromEmail, list, read, changeFromName },
      dispatch,
    )
  },
)(FromEmailSelect)
